module.exports = __webpack_public_path__ + "media/toon-link.522ba246.wav";